import { render, staticRenderFns } from "./DispatchMailList.vue?vue&type=template&id=53a78e85&lang=pug"
import script from "./DispatchMailList.vue?vue&type=script&lang=js"
export * from "./DispatchMailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports